module.exports = __webpack_public_path__ + "img/facebook.92226bc8.svg";